import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as d3 from 'd3';
import styles from './SourcesCaption.css';
import withStyles from '../../decorators/withStyles';
import {xlt} from "../../utils/utils";


class SourcesCaption extends Component {

  static propTypes = {
    impactMeta: PropTypes.object.isRequired,
    elevMeta: PropTypes.object.isRequired,
    boundaryMeta: PropTypes.object.isRequired,
    impactName: PropTypes.string.isRequired,
    openSources: PropTypes.func.isRequired,
  };

  setTxContent = el => {
    d3.select(el).attr("tx-content", "block");
  };

  render() {
    const { impactMeta, elevMeta, boundaryMeta, impactName, openSources } = this.props;

    var sourceObjs;
    if (!impactMeta.sources || !impactMeta.sources.names) {
      sourceObjs = [];
    } else {
      sourceObjs = impactMeta.sources.names.map((name, i) => {
        var datedName = name;
        const date = impactMeta.sources.mouseovers[i].match(/20[0-9]{2}/);
        if (date && !name.match(/20[0-9]{2}/)) {
          datedName += ` ${date[0]}`;
        }
        return {name: datedName, url: impactMeta.sources.urls[i], fullname: impactMeta.sources.mouseovers[i]};
      });
    }

    const impactSrcName = sourceObjs.map(src => src.name).join(", ");

    var srcsAndMethod;
    if (sourceObjs.length > 0) {
      srcsAndMethod = (
          <p ref={this.setTxContent}>Sources: Raw <var>{xlt(impactName).toLowerCase()}</var> data, <var><a
              href={sourceObjs[0].url} target="_blank">{impactSrcName}</a></var>;
            elevation data, <var><a href={elevMeta.url} target="_blank">{elevMeta.name}</a></var>;
            administrative boundaries, <var><a href={boundaryMeta.url} target="_blank">{boundaryMeta.name}</a></var>. <a
                href="" onClick={openSources}>Details</a>
          </p>
      );
    } else {
      srcsAndMethod = (
          <p ref={this.setTxContent}>Sources: Elevation data, <var><a href={elevMeta.url} target="_blank">{elevMeta.name}</a></var>;
            administrative boundaries, <var><a href={boundaryMeta.url} target="_blank">{boundaryMeta.name}</a></var>. <a
                href="" onClick={openSources}>Details</a>
          </p>
      );
    }

    // const srcCaption = ((sourceObjs.length > 0) ? srcsAndMethod : <a href="" onClick={this.props.openSources}>Methods and sources</a>);

    return (
      <div className="SourcesCaption map-explain">
        {srcsAndMethod}
      </div>
    );
  }

}

export default withStyles(styles)(SourcesCaption);
